import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.jsx';
import { RequireAuth } from './auth/RequireAuth.jsx';
import { ThemeProvider } from './theme/ThemeProvider.jsx';
import { Layout } from './components/Layout.jsx';
import { Home } from './pages/Home.jsx';
import { Login } from './pages/Login.jsx';
import { Register } from './pages/Register.jsx';
import { Picks } from './pages/Picks.jsx';
import { WeeklyLeaderboard } from './pages/WeeklyLeaderboard.jsx';
import { SeasonLeaderboard } from './pages/SeasonLeaderboard.jsx';
import { Schedule } from './pages/Schedule.jsx';
import { AdminUsers } from './pages/admin/AdminUsers.jsx';
import { AdminPicks } from './pages/admin/AdminPicks.jsx';
import { AdminInvites } from './pages/admin/AdminInvites.jsx';
import { AdminSync } from './pages/admin/AdminSync.jsx';
import './custom.css';

const authed = (element) => <RequireAuth>{element}</RequireAuth>;
const adminOnly = (element) => <RequireAuth adminOnly>{element}</RequireAuth>;

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/" element={authed(<Home />)} />
            <Route path="/picks" element={authed(<Picks />)} />
            <Route path="/schedule" element={authed(<Schedule />)} />
            <Route path="/leaderboard/weekly" element={authed(<WeeklyLeaderboard />)} />
            <Route path="/leaderboard/season" element={authed(<SeasonLeaderboard />)} />

            <Route path="/admin/users" element={adminOnly(<AdminUsers />)} />
            <Route path="/admin/picks" element={adminOnly(<AdminPicks />)} />
            <Route path="/admin/invites" element={adminOnly(<AdminInvites />)} />
            <Route path="/admin/sync" element={adminOnly(<AdminSync />)} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </ThemeProvider>
  );
}
